export default [
  'hero-display-2',
  'hero-display-3',
  'hero-display-4',
  'hero-display-5',
]
